import { useNavigate } from 'react-router-dom'
import { MainContent } from '../components/MainContent'
import { Recap } from './chaloupka/Recap'
import { MeetingRecordForm } from './MeetingRecordForm'

export const MeetingRecordSme = () => {
  const navigate = useNavigate()

  return (
    <MainContent>
      <Recap />

      {/* <MeetingRecordForm
        onSubmit={(values: MeetingRecordFormValues) => {
          console.log(values)
          navigate('/sme/wizard/completed')
        }}
      /> */}
    </MainContent>
  )
}
